import React, {useEffect, useRef, useState} from "react";
import TitleBar from "../../components/popUp/TitleBar";
import boxImg1 from "../../data/map/icon_01.png"
import boxImg2 from "../../data/map/icon_02.png"
import boxImg3 from "../../data/map/icon_03.png"
import boxImg4 from "../../data/map/icon_04.png"
import boxImg5 from "../../data/map/icon_05.png"
import boxImg6 from "../../data/map/icon_06.png"
import backImg from "../../data/map/back_sm.png"
import blackCircleImg from "../../data/pad/none_bla_200.png"
import minorCircleImg from "../../data/pad/none_yel_200.png"
import majorCircleImg from "../../data/pad/none_org_200.png"
import critCircleImg from "../../data/pad/none_red_200.png"
import fireCircleImg from "../../data/pad/none_fire_200.png"
import fcltyIcon from "../../data/icons/fclty.png"
import fcltyIconFire from '../../data/icons/fclty_fire.png'
import fcltyIconCrit from "../../data/icons/fclty_crit.png"
import fcltyIconMajor from "../../data/icons/fclty_major.png"
import fcltyIconMinor from "../../data/icons/fclty_minor.png"
import GIOJson from '../../data/map/TL_SCCO_SIG.json'
import SeoulGIO from "../../data/map/seoul_municipalities_geo_simple.json"
import {
  getCardList,
  getCardListAnon,
  getFcltyPoint,
  getFcltyPointAnon,
  getLabelList,
  getLabelListAnon
} from "../../api/apiClient";
import Swal from 'sweetalert2';
import '@sweetalert2/theme-dark/dark.scss';
import PopUp from "../../components/popUp/PopUp";
import DashFireStatus from "../DashFireStatus";

/* 대시보드 - 플랫폼 - 시설 현황 */
function sleep(ms) {
  return new Promise((r) => setTimeout(r, ms));
}

const FacilityStatus = ({
                          openLayerHandler,
                          propInitState = 0,
                          propAnonAPI = false,
                          propHomeSize = 5,
                          stSectionID,
                          setSectionID,
                          propAuth,
                        }) => {
  const map = useRef(null);
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const sectionLayerList = useRef([]);
  const infoLayerList = useRef([]);
  const labelLayerList = useRef([]);
  const markerLayerList = useRef({isDrawn: false, hMarker: []});
  const backButton = useRef({isDrawn: false, hImage: null});
  const [markerList, setMarkerList] = useState([]);
  const [cardList, setCardList] = useState([]);
  const [labelList, setLabelList] = useState([]);
  const [isReady, setReady] = useState(100);

  const [stTimeRefresher, setTimeRefresher] = useState(null);
  const [stRefreshSeed, setRefreshSeed] = useState(0);

  const blackCircle = new Image();
  blackCircle.src = blackCircleImg
  const minorCircle = new Image();
  minorCircle.src = minorCircleImg
  const majorCircle = new Image();
  majorCircle.src = majorCircleImg
  const critCircle = new Image();
  critCircle.src = critCircleImg
  const fireCircle = new Image();
  fireCircle.src = fireCircleImg

  useEffect(() => {
    console.log('Map mounting start.');
    const cssURL = "https://map.seoul.go.kr/smgis/apps/mapsvr.do?cmd=gisMapCss";
    const scriptURL = "https://map.seoul.go.kr/smgis/apps/mapsvr.do?cmd=gisMapJs&key=04e023def4484c35878dceb39ac8f765";
    //
    addStyle(cssURL);
    if (isMapLoaded == false) {
      addScript(scriptURL, initSeoulMap);
    }
    //initSeoulMap();
    console.log('Map mounting end.');

    let timeInterval = setInterval(updateCycle, 10000);
    setTimeRefresher(timeInterval);

    return () => {
      console.log("unmount");
      console.log(stTimeRefresher)
      cleanupSeoulMap();
      clearInterval(stTimeRefresher);
    };

  }, []);

  const updateCycle = () => {
    let rand = Math.random();
    console.log(`update 10s! ${rand}`);
    setRefreshSeed(rand);
    // updateCardList();
    // updateLabelList();
    // updateBackButton();
    // updateMarker();
  }

  useEffect(() => {
    console.log(`[SECTION ID] = ${stSectionID}`);
    updateCardList();
    updateLabelList();
    // updateBackButton();
    updateMarker();

  }, [stRefreshSeed])

  useEffect(() => {
    console.log(`READY COUNT = ${isReady}`);
    updateCardList();
    updateLabelList();
    // updateBackButton();
    updateMarker();
  }, [isReady]);

  const updateCardList = () => {
    let res;
    if (propAnonAPI) {
      getCardListAnon(stSectionID).then(res => {
        if (res.data != undefined) {
          setCardList(res.data.data.cardsList);
        }
      });
    } else {
      getCardList(stSectionID).then(res => {
        if (res.data != undefined) {
          setCardList(res.data.data.cardsList);
        }
      });
    }
  }

  const updateLabelList = () => {
    let res;
    if (propAnonAPI) {
      getLabelListAnon().then(res => {
        if (res.data != undefined) {
          setLabelList(res.data.data.pointsList);
        }
      });
    } else {
      getLabelList().then(res => {
        if (res.data != undefined) {
          setLabelList(res.data.data.pointsList);
        }
      });
    }
  }

  const updateMarker = () => {
    let res;
    let sid = stSectionID;
    if (sid != '0') {
      if (propAnonAPI) {
        getFcltyPointAnon(sid).then(res => {
          if (res.data != undefined) {
            setMarkerList(res.data.data.pointsList);
            console.log(res.data.data.pointsList)
          }
        });
      } else {
        getFcltyPoint(sid).then(res => {
          if (res.data != undefined) {
            setMarkerList(res.data.data.pointsList);
            console.log(res.data.data.pointsList)
          }
        });
      }
    } else {
      setMarkerList([]);
    }
  }

  const updateBackButton = () => {
    let sid = stSectionID;
    clearBackButton();
    if (sid != '0') {
      makeBackButton(backImg);
      if (propInitState == 0) {
        drawBackButton();
      }
    }
  }

  useEffect(() => {
    clearMarker();
    if (stSectionID != '0') {
      makeMarker();
      drawMarker();
    }
  }, [markerList])

  useEffect(() => {
    console.log('Change cardslist');
    console.log(cardList);
    if (isMapLoaded == true && cardList.length == 6) {
      // clearCards();
      makeCards();
      // drawCards();
    }
    // if (cardList.data != undefined){
    //     console.log(cardList.data.data);
    // }

  }, [cardList]);

  useEffect(() => {
    console.log('Change labelList');
    console.log(labelList);
    if (isMapLoaded == true && labelList.length > 0) {
      clearLabels();
      if (stSectionID == 0) {
        console.log(`sectionID = ${stSectionID}`);
        makeLabels();
        drawLabels();
      }
    }
  }, [labelList]);

  const cleanupSeoulMap = () => {
    clearCards();
    clearMarker();
    clearBackButton();
    clear_section(true);
  }

  const onChangeMapView = () => {
    let rand = Math.random();
    setRefreshSeed(rand);
  }

  const initSeoulMap = async () => {
    console.log(`init Seoul Map...  ${isMapLoaded}, ${map.current}`);
    if (isMapLoaded === false && map.current == null) {
      console.log(`init Seoul Map... Loading...  ${isMapLoaded}, ${map.current}`);
      setIsMapLoaded(true);
      let hMap = new window.L.map("mapContainer", {
        continuousWorld: false,
        worldCopyJump: false,
        zoomControl: false,
        zoomAnimation: true,
        fadeAnimation: false,
        inertia: false,
        closePopupOnClick: false,
        attributionControl: false
      });


      // hMap.scrollWheelZoom.disable();
      // hMap.dragging.disable();
      hMap.setView([37.566611, 126.978509], propHomeSize);
      window.BaseMapChange(hMap, window.L.Dawul.BASEMAP_GEN);

      map.current = hMap;

      hMap.whenReady(initAllSection, null);

      initCard('card1', boxImg1);
      initCard('card2', boxImg2);
      initCard('card3', boxImg3);
      initCard('card4', boxImg4);
      initCard('card5', boxImg5);
      initCard('card6', boxImg6);

      console.log(hMap);

      if (propInitState == 0) {
        move_seoul();
      } else {
        let sectionName = sectionCodeToName(propInitState);
        console.log(sectionName);
        moveTo(sectionName)
      }

      map.current.on('dragend', function (e) {
        onChangeMapView();
      });
      map.current.on('zoomend', function (e) {
        onChangeMapView();
      });
    }
  }

  const initAllSection = () => {
    let sections = []

    // sections.push(initSection('강서구'));
    // sections.push(initSection('양천구'));
    // sections.push(initSection('구로구'));
    // sections.push(initSection('영등포구'));
    // sections.push(initSection('금천구'));
    // sections.push(initSection('동작구'));
    // sections.push(initSection('관악구'));
    // sections.push(initSection('서초구'));
    // sections.push(initSection('강남구'));
    // sections.push(initSection('송파구'));
    // sections.push(initSection('강동구'));
    //
    // sections.push(initSection('은평구'));
    // sections.push(initSection('서대문구'));
    // sections.push(initSection('마포구'));
    // sections.push(initSection('종로구'));
    // sections.push(initSection('중구', '11140'));
    // sections.push(initSection('용산구'));
    // sections.push(initSection('강북구'));
    // sections.push(initSection('성북구'));
    // sections.push(initSection('동대문구'));
    // sections.push(initSection('성동구'));
    // sections.push(initSection('도봉구'));
    // sections.push(initSection('노원구'));
    // sections.push(initSection('중랑구'));
    // sections.push(initSection('광진구'));
    //     console.log(SeoulGIO);

    //let gio = SeoulGIO.features[0]
    SeoulGIO.features.map(elem => {
      let polygon = {
        name: 'temp',
        code: '000',
        isVisible: false,
        handle: null,
      }
      for (let i = 0; i < elem.geometry.coordinates[0].length; i++) {
        let temp;
        temp = elem.geometry.coordinates[0][i][0];
        elem.geometry.coordinates[0][i][0] = elem.geometry.coordinates[0][i][1];
        elem.geometry.coordinates[0][i][1] = temp;
      }

      polygon.name = elem.properties.name;
      polygon.code = elem.properties.code;
      polygon.handle = new window.L.geoJson(
          elem, {
            style: function () {
              return {
                clickable: false,
                weight: 4,   //라인굵기
                color: "#ffffff",  // 라인컬러
                opacity: 1,   //투명도
                fillColor: "#92c3a6",  //폴리곤 내부 컬러
                fillOpacity: 0.7  //폴리곤 내부 투명도
              };
            }
          });
      //map.current.addLayer(polygon.handle);
      sectionLayerList.current.push(polygon);
    })
    // sectionLayerList.current = sections;
  }

  // useEffect(() => {
  //     // 첫 진입시
  //     drawSeoulSection();
  // }, [sectionLayerList]);

  const makeLabels = () => {
    if (labelList.length > 0) {
      labelLayerList.current = [];
      for (let i = 0; i < labelList.length; i++) {
        //console.log(labelList[i]);
        let label = {};
        let label_center = {lat: labelList[i].la, lng: labelList[i].lo}
        let label_bound = calcCenterBound(label_center, 40, 60);

        // label.handle = new window.L.ImageOverlay(makeSectionLabel(
        //     labelList[i].atdrc_nm, labelList[i].alarm_cnt, labelList[i].total_cnt, labelList[i].fire_sttus),
        //     label_bound, { opacity: 1});
        // handle: new window.L.Marker(bounds[1].getCenter(), {
        //     icon: new window.L.Icon({
        //         iconUrl: insertCardText('card2', boxImg1,
        //             '' + cardList[1].total_co, '' + cardList[1].alarm_co),
        //         iconAnchor: [80, 40],
        //     }),
        // }),

        label.handle = new window.L.Marker(label_bound.getCenter(), {
          icon: new window.L.Icon({
            iconUrl: makeSectionLabel(labelList[i].atdrc_nm, labelList[i].alarm_cnt,
                labelList[i].total_cnt, labelList[i].fire_sttus, labelList[i].serius_level),
            iconAnchor: [20, 30],
          }),
        });
        label.handle.addEventListener('click', moveTo.bind(null, labelList[i].atdrc_nm));
        label.isVisible = false;

        labelLayerList.current.push(label);
      }
    }

    // let label_center = polygon.handle.getBounds().getCenter();
    // let label_bound = calcCenterBound(label_center, 40, 60);
    //
    // polygon.label_handle = new window.L.ImageOverlay(makeSectionLabel(name), label_bound, { opacity: 1});
    // //polygon.label_handle.addEventListener('click', moveTo.bind(null, polygon.name));
  }

  const drawLabels = () => {
    console.log('draw labels');
    console.log(labelLayerList);
    let label = {
      handle: null,
      isVisible: false,
    }

    for (let i = 0; i < labelLayerList.current.length; i++) {
      label = labelLayerList.current[i];
      if (label.handle != null) {
        label.handle.addTo(map.current);
        label.isVisible = true;
      }
    }
  }

  const clearLabels = () => {
    for (let i = 0; i < labelLayerList.current.length; i++) {
      map.current.removeLayer(labelLayerList.current[i].handle);
      labelLayerList.current[i].isVisible = false;
    }
    labelLayerList.current = [];
  }


  const initCard = (id, frame_img) => {
    let canvasTxt = window.document.getElementById(id).getContext("2d");
    canvasTxt.canvas.width = 160;
    canvasTxt.canvas.height = 80;
    let base_image = new Image();
    base_image.src = frame_img;
    base_image.onload = function () {
      //console.log('loading image');
      canvasTxt.drawImage(base_image, 0, 0);
    }
  }

  const makeCards = () => {
    console.log('make Cards');
    let bounds = [
      calcBound(10, 20, 160, 80),
      calcBound(10, 120, 160, 80),
      calcBound(10, 220, 160, 80),
      calcBound(-10, 20, 160, 80),
      calcBound(-10, 120, 160, 80),
      calcBound(-10, 220, 160, 80)];


    console.log(bounds);
    console.log(bounds[0].getCenter());

    console.log(cardList);

    //console.log(boxImg1);
    //console.log(textToImage());
    let card = [];
    card[0] = {
      // handle: new window.L.ImageOverlay(insertCardText('card1', boxImg1,
      // '' + cardList[0].total_co, '' + cardList[0].alarm_co), bounds[0], { opacity: 1}),
      handle: new window.L.Marker(bounds[0].getCenter(), {
        icon: new window.L.Icon({
          iconUrl: insertCardText('card1', boxImg1,
              '', cardList[0].total_co + ' 개소'),
          iconAnchor: [80, 40],
        }),
      }),
      isVisible: false,
    }
    card[1] = {
      // handle: new window.L.ImageOverlay(insertCardText('card2', boxImg2,
      // '' + cardList[1].total_co, '' + cardList[1].alarm_co), bounds[1], { opacity: 1}),
      handle: new window.L.Marker(bounds[1].getCenter(), {
        icon: new window.L.Icon({
          iconUrl: insertCardText('card2', boxImg2,
              '', cardList[1].total_co + ' 대'),
          iconAnchor: [80, 40],
        }),
      }),
      isVisible: false,
    }
    card[2] = {
      // handle: new window.L.ImageOverlay(insertCardText('card3', boxImg3,
      // '' + cardList[2].total_co, '' + cardList[2].alarm_co), bounds[2], { opacity: 1}),
      handle: new window.L.Marker(bounds[2].getCenter(), {
        icon: new window.L.Icon({
          iconUrl: insertCardText('card3', boxImg3,
              '', cardList[2].total_co + ' 대'),
          iconAnchor: [80, 40],
        }),
      }),
      isVisible: false,
    }
    card[3] = {
      // handle: new window.L.ImageOverlay(insertCardText('card4', boxImg4,
      // '' + cardList[3].total_co, '' + cardList[3].alarm_co), bounds[3], { opacity: 1}),
      handle: new window.L.Marker(bounds[3].getCenter(), {
        icon: new window.L.Icon({
          iconUrl: insertCardText('card4', boxImg4,
              '', cardList[3].total_co + ' 대'),
          iconAnchor: [80, 40],
        }),
      }),
      isVisible: false,
    }
    card[4] = {
      // handle: new window.L.ImageOverlay(insertCardText('card5', boxImg5,
      // '' + cardList[4].total_co, '' + cardList[4].alarm_co), bounds[4], { opacity: 1}),
      handle: new window.L.Marker(bounds[4].getCenter(), {
        icon: new window.L.Icon({
          iconUrl: insertCardText('card5', boxImg5,
              '', cardList[4].total_co + ' 대'),
          iconAnchor: [80, 40],
        }),
      }),
      isVisible: false,
    }
    card[5] = {
      // handle: new window.L.ImageOverlay(insertCardText('card6', boxImg6,
      // '' + cardList[5].total_co, '' + cardList[5].alarm_co), bounds[5], { opacity: 1}),
      handle: new window.L.Marker(bounds[5].getCenter(), {
        icon: new window.L.Icon({
          iconUrl: insertCardText('card6', boxImg6,
              '', cardList[5].total_co + ' 대'),
          iconAnchor: [80, 40],
        }),
      }),
      isVisible: false,
    }

    if (infoLayerList.current.length == 6) {
      infoLayerList.current[0] = card[0];
      infoLayerList.current[1] = card[1]
      infoLayerList.current[2] = card[2]
      infoLayerList.current[3] = card[3]
      infoLayerList.current[4] = card[4]
      infoLayerList.current[5] = card[5]
    } else {
      infoLayerList.current.push(card[0]);
      infoLayerList.current.push(card[1]);
      infoLayerList.current.push(card[2]);
      infoLayerList.current.push(card[3]);
      infoLayerList.current.push(card[4]);
      infoLayerList.current.push(card[5]);
    }
    infoLayerList.current[0].handle.addEventListener('click', showFirePopup);
  }

  const clearCards = () => {
    console.log('clear card start');
    let cnt = 0;
    let infoCard;

    for (let i = 0; i < infoLayerList.current.length; i++) {
      infoCard = infoLayerList.current[i];
      if (infoCard.isVisible) {
        // console.log(infoCard);
        map.current.removeLayer(infoCard.handle);
        cnt++;
        infoCard.isVisible = false;
      }
    }
    console.log(`clear ${cnt} layers.`);
    console.log(infoLayerList);
  }

  const insertCardText = (id, frame_img, line1, line2) => {
    let canvasTxt = window.document.getElementById(id).getContext("2d");
    canvasTxt.canvas.width = 160;
    canvasTxt.canvas.height = 80;
    let base_image = new Image();
    base_image.src = frame_img;
    base_image.onload = function () {
      //console.log('loading image');
      canvasTxt.drawImage(base_image, 0, 0);
      canvasTxt.font = '15px Arial'
      canvasTxt.fillStyle = 'white';
      canvasTxt.textAlign = 'right'
      canvasTxt.fillText(line1, '85', '30');
      canvasTxt.fillText(line2, '140', '67');
    }

    let ret = canvasTxt.canvas.toDataURL();
    //console.log(ret);
    //initCard(id, frame_img);

    return ret;
  }

  const clearBackButton = () => {
    // clear image layer
    if (backButton.current.isDrawn == true) {
      map.current.removeLayer(backButton.current.hImage);
      // map.current.removeLayer(backButton.current.hPolygon);
      backButton.current.isDrawn = false;
    }
  }

  const makeBackButton = (frame_img) => {
    let bound = calcBound(10, -10, 123, 40);

    // make image layer
    // backButton.current.hImage = new window.L.ImageOverlay(frame_img, bound, { opacity: 1});
    backButton.current.hImage = new window.L.Marker(bound.getCenter(), {
      icon: new window.L.Icon({
        iconUrl: frame_img,
        iconAnchor: [65, 20],
      }),
    });
    backButton.current.hImage.addEventListener('click', move_seoul);
  }

  const drawBackButton = () => {

    if (backButton.current.isDrawn == false) {
      // draw image layer
      backButton.current.hImage.addTo(map.current);
      // backButton.current.hImage.bringToBack();
      // draw polygon
      // backButton.current.hPolygon.addTo(map.current);
      //backButton.current.hPolygon.bringToBack();
      backButton.current.isDrawn = true;
    }
  }

  const clearMarker = () => {
    if (markerLayerList.current.isDrawn == true) {
      for (let i = 0; i < markerLayerList.current.hMarker.length; i++) {
        //alert('draw');
        map.current.removeLayer(markerLayerList.current.hMarker[i]);
      }
      markerLayerList.current.isDrawn = false;
    }
  };

  const makeMarker = () => {
    console.log('make Marker');
    console.log(markerList);
    console.log(markerList.length);

    markerLayerList.current.hMarker = [];
    for (let i = 0; i < markerList.length; i++) {
      let elem = markerList[i];
      let icon

      if (elem.serius_level == 0) {
        icon = fcltyIcon
      } else if (elem.serius_level == 1) {
        icon = fcltyIconMinor
      } else if (elem.serius_level == 2) {
        icon = fcltyIconMajor
      } else if (elem.serius_level == 3) {
        icon = fcltyIconCrit
      }

      if (elem.fire_sttus == 1) {
        icon = fcltyIconFire
      }
      let hMarker = new window.L.Marker(new window.L.LatLng(elem.la, elem.lo), {
        icon: new window.L.Icon({   // 마커 찍기
          iconUrl: icon,   //핀 이미지
          iconAnchor: [0, 0],  // 오프셋 (핀의 끝이 좌표로 매칭하기 위해 적용)
        }),
        title: elem.fclty_nm,
      });
      console.log('marker!!');
      hMarker.addEventListener('click', clickFclty.bind(null, elem.fclty_no));
      markerLayerList.current.hMarker.push(hMarker);
    }
    console.log(markerLayerList);
  }

  const drawMarker = () => {
    for (let i = 0; i < markerLayerList.current.hMarker.length; i++) {
      //alert('draw');
      markerLayerList.current.hMarker[i].addTo(map.current);
    }
    markerLayerList.current.isDrawn = true;
  }

  const initSection = (name, code = '0') => {
    let data = GIOJson.features;
    console.log(`initPolygon (${name}, ${code});`);

    let object;
    if (code === '0') {
      //console.log('name search')
      data.map(elem => {
        if (elem.properties.SIG_KOR_NM === name) {
          object = elem;
          console.log(elem);
        }
      })
    } else {
      //console.log('code search')
      data.map(elem => {
        if (elem.properties.SIG_CD === code) {
          object = elem;
          console.log(elem);
        }
      })
    }

    code = object.properties.SIG_CD;

    let polygon = {
      name: 'temp',
      code: '000',
      isVisible: false,
      handle: null,
    }

    polygon.name = name;
    polygon.code = code;

    for (let i = 0; i < object.geometry.coordinates[0].length; i++) {
      let temp;
      temp = object.geometry.coordinates[0][i][0];
      object.geometry.coordinates[0][i][0] = object.geometry.coordinates[0][i][1];
      object.geometry.coordinates[0][i][1] = temp;
    }

    // object.geometry.type = 'LineString';

    // polygon.handle = new window.L.GeoJSON(
    polygon.handle = new window.L.geoJson(
        object, {
          style: function () {
            return {
              clickable: false,
              weight: 4,   //라인굵기
              color: "#ffffff",  // 라인컬러
              opacity: 1,   //투명도
              fillColor: "#92c3a6",  //폴리곤 내부 컬러
              fillOpacity: 0.7  //폴리곤 내부 투명도
            };
          }
        });

    // polygon.handle = new window.L.Polyline(object.geometry.coordinates[0], {});

    console.log(`binding moveTo(${polygon.name})`);
    //polygon.handle.addEventListener('click', moveTo.bind(null, polygon.name));

    //polygonLayerList.current.push(polygon);
    return polygon;
    //console.log(object);
  }

  const makeSectionLabel = (name, val = '0', max = '10', danger = '0', serius_level = '0') => {
    let canvasTxt = window.document.getElementById('sectionLabel').getContext("2d");
    let cnvs = window.document.getElementById('sectionLabel');

    canvasTxt.canvas.width = 40;
    canvasTxt.canvas.height = 60 + 11;

    // canvasTxt.beginPath();
    //
    // // 4. 원 모양 설정
    // canvasTxt.arc(20, 20, 20, 0, 2 * Math.PI);
    //
    // // 5. 그리기
    // canvasTxt.stroke();
    //
    // // 6. 원 내부 색 채우기
    //
    // if (serius_level == '0') {
    //     // canvasTxt.fillStyle = '#2b3b32';
    //     canvasTxt.fillStyle = '#2b3b32';
    // } else if (serius_level == '1') {
    //     // canvasTxt.fillStyle = '#866f22';
    //     canvasTxt.fillStyle = '#ffc600';
    // } else if (serius_level == '2') {
    //     // canvasTxt.fillStyle = '#894f23';
    //     canvasTxt.fillStyle = '#fe8428';
    // } else {
    //     // canvasTxt.fillStyle = '#97181d';
    //     canvasTxt.fillStyle = '#fd001a';
    // }
    // if (danger != '0') {
    //     canvasTxt.fillStyle = '#ff00ff';
    // }
    //
    //
    // canvasTxt.fill();

    // let base_image = new Image();
    // base_image.src = boxImg;
    // base_image.onload = function () {
    //     console.log('loading image');
    //     canvasTxt.drawImage(blackCircle, 0, 0, 40, 40);
    // }

    if (danger != '0') {
      canvasTxt.drawImage(fireCircle, 0, 0, 40, 51);
    } else if (serius_level == '0') {
      canvasTxt.drawImage(blackCircle, 0, 11, 40, 40);
    } else if (serius_level == '1') {
      canvasTxt.drawImage(minorCircle, 0, 11, 40, 40);
    } else if (serius_level == '2') {
      canvasTxt.drawImage(majorCircle, 0, 11, 40, 40);
    } else if (serius_level == '3') {
      canvasTxt.drawImage(critCircle, 0, 11, 40, 40);
    }

    canvasTxt.font = '15px Arial bold'
    canvasTxt.textAlign = 'center'
    canvasTxt.fillStyle = 'white';
    canvasTxt.fillText(val + '/' + max, '20', '36');
    canvasTxt.font = '10px Arial bold'
    canvasTxt.textAlign = 'center'
    canvasTxt.fillStyle = 'black';
    canvasTxt.fillText(name, '20', '66');

    let ret = canvasTxt.canvas.toDataURL();
    //console.log(ret);


    // 픽셀 정리
    canvasTxt.clearRect(0, 0, cnvs.width, cnvs.height);
    // 컨텍스트 리셋
    canvasTxt.beginPath();

    return ret;
  }

  const clear_section = (isForceClear = false) => {
    console.log('clear polygon start');
    let cnt = 0;
    let polygon;
    console.log(sectionLayerList);

    for (let i = 0; i < sectionLayerList.current.length; i++) {
      polygon = sectionLayerList.current[i];
      if (polygon.isVisible) {
        //console.log(polygon);
        map.current.removeLayer(polygon.handle);
        if (isForceClear) {
          polygon.handle = null;
        }
        cnt++;
        polygon.isVisible = false;
      }
    }
    console.log(`clear ${cnt} layers.`);
    console.log(sectionLayerList);
  }

  const draw_polygon = (name) => {
    let polygon = {
      name: 'temp',
      code: '000',
      handle: null,
      isVisible: false
    }

    sectionLayerList.current.map(elem => {
      if (elem.name === name) {
        polygon = elem;
      }
    })

    if (polygon.handle != null) {
      console.log(`find polygon.`);
      if (polygon.isVisible == false) {
        console.log(`add for draw.`);
        let ret;
        // ret = polygon.handle.addTo(map.current);
        map.current.addLayer(polygon.handle);
        // if (ret._map === map.current) {
        //     console.log('match!')
        // }
        console.log(ret);
        polygon.isVisible = true;
      }
    }
  }

  const drawCards = () => {
    for (let i = 0; i < infoLayerList.current.length; i++) {
      if (infoLayerList.current[i].isVisible == false) {
        infoLayerList.current[i].handle.addTo(map.current);
        infoLayerList.current[i].isVisible = true;
      }
    }
  }

  const calcBound = (x_margin, y_margin, width, height) => {
    let pxWidth, pxHeight, lWidth, lHeight;
    let pixBound = map.current.getPixelBounds();
    let lBound = map.current.getBounds();
    let calcEast, calcWest, calcNorth, calcSouth;
    //console.log(lBound);
    //console.log(pixBound);

    pxWidth = pixBound.max.x - pixBound.min.x;
    pxHeight = pixBound.max.y - pixBound.min.y;
    lWidth = lBound.getEast() - lBound.getWest();
    lHeight = lBound.getNorth() - lBound.getSouth();

    //console.log(lHeight);

    if (x_margin >= 0) {
      calcWest = lBound.getWest() + ((lWidth / pxWidth) * x_margin);
      calcEast = calcWest + ((lWidth / pxWidth) * width);
    } else {
      calcEast = lBound.getEast() + ((lWidth / pxWidth) * x_margin);
      calcWest = calcEast - ((lWidth / pxWidth) * width);
    }

    if (y_margin >= 0) {
      calcNorth = lBound.getNorth() - ((lHeight / pxHeight) * y_margin);
      calcSouth = calcNorth - ((lHeight / pxHeight) * height);
    } else {
      calcSouth = lBound.getSouth() - ((lHeight / pxHeight * y_margin));
      calcNorth = calcSouth + ((lHeight / pxHeight) * height);
    }

    return new window.L.LatLngBounds({lat: calcSouth, lng: calcWest}, {lat: calcNorth, lng: calcEast});
  }

  const calcCenterBound = (center, width, height) => {
    let pxWidth, pxHeight, lWidth, lHeight;
    let pixBound = map.current.getPixelBounds();
    let lBound = map.current.getBounds();
    let calcEast, calcWest, calcNorth, calcSouth;
    //console.log(lBound);
    //console.log(pixBound);

    pxWidth = pixBound.max.x - pixBound.min.x;
    pxHeight = pixBound.max.y - pixBound.min.y;
    lWidth = lBound.getEast() - lBound.getWest();
    lHeight = lBound.getNorth() - lBound.getSouth();

    //console.log(lHeight);

    calcWest = center.lng - ((lWidth / pxWidth) * width / 2);
    calcEast = center.lng + ((lWidth / pxWidth) * width / 2);

    calcNorth = center.lat + ((lHeight / pxHeight) * height / 2);
    calcSouth = center.lat - ((lHeight / pxHeight) * height / 2);

    return new window.L.LatLngBounds({lat: calcSouth, lng: calcWest}, {lat: calcNorth, lng: calcEast});
  }


  const getXY = () => {
    let center = this.state.map.getCenter();
    let zoom = this.state.map.getZoom();
    console.log(`get xy [${center.lat}, ${center.lng}], ${zoom}`);
  }

  const drawSeoulSection = () => {
    draw_polygon('강서구');
    draw_polygon('양천구');
    draw_polygon('구로구');
    draw_polygon('영등포구');
    draw_polygon('금천구');
    draw_polygon('동작구');
    draw_polygon('관악구');
    draw_polygon('서초구');
    draw_polygon('강남구');
    draw_polygon('송파구');
    draw_polygon('강동구');

    draw_polygon('은평구');
    draw_polygon('서대문구');
    draw_polygon('마포구');
    draw_polygon('종로구');
    draw_polygon('중구', '11140');
    draw_polygon('용산구');
    draw_polygon('강북구');
    draw_polygon('성북구');
    draw_polygon('동대문구');
    draw_polygon('성동구');
    draw_polygon('도봉구');
    draw_polygon('노원구');
    draw_polygon('중랑구');
    draw_polygon('광진구');
  }

  const move_seoul = () => {
    console.log('move!!!');
    map.current.setView([37.566611, 126.978509], propHomeSize);

    clear_section();

    drawSeoulSection();

    console.log(`timer!!! ${isReady}`);
    sleep(1000).then(() => {
      setReady(Math.random());
      console.log(`!!!endTimer`);
    });


    setSectionID('0');
  }

  const map_fit = (name, zoom = 7) => {
    console.log('fitting map!!!');
    let polygon = {
      name: 'temp',
      code: '000',
      handle: null,
      isVisible: false
    }

    sectionLayerList.current.map(elem => {
      if (elem.name === name) {
        polygon = elem;
      }
    });
    console.log(polygon)
    map.current.fitBounds(polygon.handle.getBounds(), {});
    map.current.whenReady(() => {
      console.log('!!! move end.');
    })
    console.log(`timer!!! ${isReady}`);
    sleep(1000).then(() => {
      setReady(Math.random());
      console.log(`!!!endTimer`);

    });
  }

  const nameToSectionNum = (name) => {
    let polygon = {
      name: 'temp',
      code: '00000',
      handle: null,
      isVisible: false
    };

    sectionLayerList.current.map(elem => {
      if (elem.name === name) {
        polygon = elem;
      }
    });

    let ret = polygon.code + '00000';
    console.log(`code ${name}, ${ret}`);

    return ret;
  }

  const sectionCodeToName = (code) => {
    let polygon = {
      name: 'temp',
      code: '00000',
      handle: null,
      isVisible: false
    };

    sectionLayerList.current.map(elem => {
      if (elem.code == code || elem.code + '00000' == code) {
        polygon = elem;
      }
    });

    let ret = polygon.name;
    console.log(`name ${code}, ${ret}`);

    return ret;
  }


  const moveTo = (name) => {
    console.log(`moveTo ${name}`);
    setSectionID(nameToSectionNum(name));
    clear_section();
    draw_polygon(name);

    // console.log('move!!!');
    map_fit(name);
  }


  const map_test = () => {
    console.log('test!!!');
    console.log(window.L);
    console.log(map);
    console.log(sectionLayerList);


    Swal.fire({
      icon: 'error',
      title: '화재 발생',
      text: '2022-12-15 15:31 STI(테스트) 화재 발생!',
    });
    // console.log(openLayerHandler);
    // openLayerHandler();
  }

  const clickFclty = (fclty) => {
    // Swal.fire({
    //     icon: 'info',
    //     title: '시설 정보',
    //     text: `시설 정보를 호출합니다. ${fclty}`,
    // });
    openLayerHandler(fclty);
  }

  const [stFirePopShow, setFirePopShow] = useState(false);
  const showFirePopup = () => {
    setFirePopShow(true)
  }

  return (
      <div className={`content-container mb-4 ${propAnonAPI ? "map" : ''}`}>
        <PopUp
            propTitle={'화재현황'}
            propShow={stFirePopShow}
            setShow={setFirePopShow}
            propDialogClassName={"modal-90w"}
        >
          <DashFireStatus
              propAuth={propAuth}
          />
        </PopUp>
        <TitleBar title={"이동약자시설 현황"}/>
        <div className={"content-container-body p-3"}>
          <div id='mapContainer' className={"map-container"}>
            <canvas id="card1" onClick={propAnonAPI === false ? showFirePopup : undefined}/>
            <canvas id="card2"/>
            <canvas id="card3"/>
            <canvas id="card4"/>
            <canvas id="card5"/>
            <canvas id="card6"/>
            <canvas id="sectionLabel" style={{display: "none"}}/>
            <img src={backImg} id="backButton"
                 onClick={move_seoul}
            />
          </div>
          {/*지도 구현 예정:*/}
          {/*<button onClick={move_seoul}> 서울 전체 지도</button>*/}

          {/*테스트 버튼:*/}
          {/*<button onClick={getXY}> 좌표!!! </button>*/}
          {/*<button onClick={map_test}> 테스트 </button>*/}
        </div>
      </div>
  );
};

const addStyle = url => {
  const style = document.createElement("link");
  style.href = url;
  style.rel = "stylesheet";
  style.async = true;
  document.head.appendChild(style);
};

const addScript = (url, onload) => {
  const script = document.createElement('script');
  script.src = url;
  script.type = 'text/javascript';
  script.async = true;
  script.onload = onload;
  document.body.appendChild(script);

  return () => {
    document.body.removeChild(script);
  }
};

export default FacilityStatus;
